import { useLocation } from "react-router-dom";

import { Tab, Tabs } from "components/layout";
import { RestrictedArea, ROLES } from "containers/Permissions";

export type TiVoDeviceTab = {
  label: string;
  link?: string;
  adminOnly?: boolean;
};

export function TiVoDeviceTabs({ tabs }: { tabs: TiVoDeviceTab[] }) {
  const { pathname } = useLocation();

  return (
    <Tabs>
      {tabs.map((tab) =>
        tab.adminOnly ? (
          <RestrictedArea
            key={tab.label}
            allowed={[ROLES.tivoDevices.admin]}
            showFallback={false}
          >
            <Tab
              active={tab.link === pathname}
              text={tab.label}
              to={tab.link}
            />
          </RestrictedArea>
        ) : (
          <Tab
            active={tab.link === pathname}
            text={tab.label}
            key={tab.label}
            to={tab.link}
          />
        )
      )}
    </Tabs>
  );
}
